import { contentTagging } from '../onbrand.js';

const helper = require('./helperFunctions.js');

module.exports = function aiPartial() {
  // custom English Hub functions

  let aiLoaded = false;
  Hubs.Events.on('load', () => {
    if (!aiLoaded) {
      // call custom English Hub functions

      aiLoaded = true;
    }
  }).on('pageChange', () => {
    // call custom English Hub functions
  });
};



// WEBPACK FOOTER //
// ./scriptPartials/ai.js